import React from 'react';
import axios from 'axios';
import { Table, Space, Button, Popconfirm, Tooltip, notification } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import FormP from './Form';
import Spinner from '../../components/spinner';
import * as filter from '../../global/FilterFun';
import AdminHeader from '../../components/adminHeader';

class paddockList extends React.Component{
    state = { regs: [], visible: false, rowToEdit: [], loading: false, 
    showNew: false, regionList: []}

    componentDidMount(){      
      this.setState({loading: true})
      axios.defaults.headers = {
          "Content-Type": "application/json",
          Authorization: "Token "+localStorage.getItem('token')
      }
      axios.get(`/api/paddock/`).then(
          res => {
              this.setState({regs: res.data, loading:false})
          }
      );

      axios.get(`/api/racecourse/region/list/`).then(
          res => {
              this.setState({regionList: res.data, loading:false})
          }
      );
    }

    getColumnSearchProps = dataIndex => filter.getColumnSearchProps(dataIndex)     
    
    showModal = id => {
      this.setState({loading: true});
      axios.get(`/api/paddock/${id}/`).then(
          res => {
              this.setState({rowToEdit: res.data, visible: true, loading: false})
          }
      );
    };

    delete = id => {
      this.setState({loading: true});
      axios.delete(`/api/paddock/${id}/`).then(
          res => {
            notification["success"]({
              message: 'Registro eliminado exitosamente',
            });
            this.setState({loading: false});
            this.componentDidMount();
          }
      );
    };
  
    showNew = b => {
      this.setState({
        showNew: b,
      });
    };

    regSaved = s =>{
      this.showNew(false)
      if(s === true){
        this.componentDidMount()
      }
    }
  
    handleCancel = e => {
      this.setState({
        visible: false,
      });
      if(e === true){
        this.componentDidMount()
      }
    };

    render(){
        const regionFilter = this.state.regionList.map(function (data, idx) {
          return {'text' : data.name, 'value' : data.name, 'key' : idx}
        });

        const columns = [
            {
              title: 'Región',
              render: (record) => record.region.name,
              filters: regionFilter,
              filterMultiple: false,
              onFilter: (value, record) => record.region.name.indexOf(value) === 0,
              sortDirections: ['descend', 'ascend'],
            },
            {
              title: 'Nombre',
              dataIndex: 'name',
              ...this.getColumnSearchProps('name'),
              sorter: (a, b) => a.name.localeCompare(b.name),
              sortDirections: ['ascend', 'descend'],
            },
            {
                title: 'Acciones',
                key: 'action',
                width: '20%',
                render: (text, record) => (
                  <Space size="middle">
                    <Tooltip title="Editar">
                      <Button type="primary" onClick={() => this.showModal(record.id)}>
                        <EditOutlined />
                      </Button>
                    </Tooltip>
                    <Popconfirm title="Eliminará un registro, ¿continuar?"
                      onConfirm={() => this.delete(record.id)}
                      onCancel={this.cancel}
                      okText="Si"
                      cancelText="No"
                    >
                      <Tooltip title="Eliminar">
                        <Button type="primary" danger>
                          <DeleteOutlined />
                        </Button>
                      </Tooltip>
                    </Popconfirm>
                  </Space>
                ),
            },
          ];
        return(
            <div>
                { localStorage.getItem('token') == null ? this.props.history.push('/login') : ''}
                <AdminHeader title="Potreros" showNew={this.showNew} />
                <Spinner spinning={this.state.loading}>
                  <Table columns={columns} dataSource={this.state.regs} pagination={true} />
                  <FormP visible={this.state.visible} onCancel={this.handleCancel}
                    data={this.state.rowToEdit} regionList={this.state.regionList} />

                  <FormP visible={this.state.showNew}  onCancel={this.regSaved}
                    regionList={this.state.regionList} />
                </Spinner>
            </div>
        );
    }
}

export default paddockList;